import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import styled, { keyframes } from "styled-components";
export const SkeletonBuilder = memo(({ builder }) => {
    return (_jsx(_Fragment, { children: builder?.map((item, index) => {
            const items = [...new Array(item.count || 1)].map((_, i) => (_jsx(Skeleton, { "$size": item.size || "medium" }, i)));
            return item.direction === "column" ? (_jsx(Column, { "$bottom": item.bottom, "$width": item.width, children: items }, index)) : (_jsx(Row, { "$bottom": item.bottom, "$width": item.width, children: items }, index));
        }) }));
});
const SkeletonAnim = keyframes `
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`;
const sizeSchema = {
    small: "10px",
    medium: "14px",
    normal: "20px",
    large: "32px",
};
export const Skeleton = styled.div `
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    ${(props) => props.$colorOne || props.theme.systemColors.grey200} 35%,
    ${(props) => props.$colorTwo || props.theme.systemColors.grey100} 60%,
    ${(props) => props.$colorOne || props.theme.systemColors.grey200} 80%
  );
  background-size: 400% 100%;
  animation: ${SkeletonAnim} 1.5s infinite;
  height: ${({ $size }) => sizeSchema[$size || "medium"]};
  width: ${({ $width }) => $width ? (typeof $width === "number" ? `${$width}px` : $width) : "100%"};
`;
const Row = styled.div `
  display: flex;
  width: 100%;
  gap: 8px;
  margin-bottom: ${({ $bottom }) => ($bottom ?? 8) + "px"};

  ${Skeleton} {
    width: 100%;
    max-width: ${({ $width }) => ($width ? $width + "px" : "100%")};
  }
`;
const Column = styled(Row) `
  flex-direction: column;
`;
